import { render, staticRenderFns } from "./shareSetting.vue?vue&type=template&id=b0437520&scoped=true&"
import script from "./shareSetting.vue?vue&type=script&lang=js&"
export * from "./shareSetting.vue?vue&type=script&lang=js&"
import style0 from "./shareSetting.vue?vue&type=style&index=0&id=b0437520&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0437520",
  null
  
)

export default component.exports